import { loadStripe } from "@stripe/stripe-js";
import { apiGet } from "@/lib/api";

let stripePromise = null;
let publishableKey = null;
let stripeMode = null;

export async function getStripe() {
  if (stripePromise) return stripePromise;
  stripePromise = (async () => {
    const cfg = await apiGet("/stripe/public-config", { auth: false });
    publishableKey = cfg.publishableKey;
    stripeMode = cfg.mode;
    return loadStripe(publishableKey);
  })();
  return stripePromise;
}

export function getStripeMode() {
  return stripeMode;
}
